import script from "./MyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyButton.vue?vue&type=script&setup=true&lang=ts"

import "./MyButton.vue?vue&type=style&index=0&id=58c0d879&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c0d879"]])

export default __exports__